var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"alert alert-success"},[_vm._v("You have successfully registered for this workshop. Your workshop details are displayed below!")]),(!_vm.isLoading)?_c('workshop-information',{attrs:{"workshop":_vm.workshop,"show-enroll":false}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }